<template>
  <SvoiCheckboxGroup v-bind="$attrs" />
</template>

<script lang="ts" setup>
import { SvoiCheckboxGroup } from '@svoi-ui/components/checkbox'
</script>
